// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format1 } from '../../constants';

/** Tuvalu */
const TV: PhoneNumberData = [688, 'TV', 7, format1];

export default TV;
